class ValidateInput {
    static phone(e, elem) {
      e.preventDefault()
      const PHONE_LENGTH = 13
      const MIN_PHONE_LENGTH = 4
      const clearNumber =  elem.value.replaceAll(' ', '')
      if((Number(e.key) || Number(e.key) === 0) && clearNumber.length < PHONE_LENGTH) elem.value = elem.value + e.key
      if(e.key === "Backspace" && clearNumber.length > MIN_PHONE_LENGTH) elem.value = elem.value.slice(0, -1)
    }
    static default(e, elem) {}
}
export default ValidateInput